// extracted by mini-css-extract-plugin
export default {"container":"NavigateBackWithContent_container__vbF4e","icon":"NavigateBackWithContent_icon__Keab8"};